import { NBSP } from 'shared/constants/symbols';
import { EDescriptionType, TContent, TFirstBlockContent } from './types';
import { Main } from 'shared/components/Main';
import { CoreBusiness } from 'shared/components/CoreBusiness';
import { TransactionalBusiness } from 'shared/components/TransactionalBusiness';
import { DailyBusiness } from 'shared/components/DailyBusiness';
import { TechnologiesCian } from 'shared/components/TechnologiesCian';
import { ENavigation } from 'shared/types/navigation';

export const FIRST_BLOCK_CONTENT: TFirstBlockContent = {
  main: {
    imageClass: 'main-page',
    title: 'Как устроен Циан: ',
    needBigFont: true,
    description: [
      [
        {
          type: EDescriptionType.Text,
          text: `бизнес-модель, сервисы${NBSP}и${NBSP}технологии`,
        },
      ],
    ],
  },
  'core-business': {
    imageClass: 'core-business-page',
    title: 'Основной бизнес',
    description: [
      [
        {
          text: `Основной бизнес Циан состоит из двух больших направлений — работа${NBSP}со${NBSP}`,
          type: EDescriptionType.Text,
        },
        { text: `вторичным рынком`, type: EDescriptionType.AnchorLink, url: ENavigation.SecondaryMarket },
        { text: ' и ', type: EDescriptionType.Text },
        { text: `новостройками.`, type: EDescriptionType.AnchorLink, url: ENavigation.FirstMarket },
      ],
      [
        {
          text: `Мы закрываем ключевые потребности пользователей: поиск и продажу жилья на «вторичке», а также выбор и покупку квартир у застройщиков. Читайте о том, как устроена монетизация в каждом из направлений и какие продукты помогают участникам рынка достигать своих целей.`,
          type: EDescriptionType.Text,
        },
      ],
    ],
  },
  'transactional-business': {
    imageClass: 'transactional-business-page',
    title: 'Транзакционный бизнес',
    description: [
      [
        {
          text: `Транзакционный бизнес в Циан — это набор цифровых сервисов для операций с недвижимостью от подбора ипотеки до регистрации и завершения сделок. Направление расширяет платформу за пределы поиска и размещения объявлений, усиливает систему и создает новые источники роста.`,
          type: EDescriptionType.Text,
        },
      ],
      [
        {
          text: 'Цифровизация сделок — глобальный тренд, Циан инвестирует в его развитие, чтобы быть на шаг впереди',
          type: EDescriptionType.Text,
        },
      ],
    ],
  },
  'daily-business': {
    imageClass: 'daily-business',
    title: 'Посуточная аренда',
    description: [
      [
        { text: 'Краткосрочная аренда', type: EDescriptionType.Link, url: 'https://www.cian.ru/posutochno/' },
        {
          text: ' — направление в экосистеме Циан, которое демонстрирует устойчивый рост и усиливает позиции компании на рынке. Сегодня её вклад в общую выручку — около 6%, а количество бронирований ежегодно увеличивается на 25–30%.',
          type: EDescriptionType.Text,
        },
      ],
    ],
  },
  'technologies-cian': {
    imageClass: 'technologies-cian',
    title: 'Технологии Циан',
    description: [
      [
        {
          text: `Мы${NBSP}одна из${NBSP}крупнейших онлайн-платформ недвижимости в${NBSP}России, которой каждый месяц доверяют 20${NBSP}млн${NBSP}пользователей. Уже${NBSP}24${NBSP}года мы${NBSP}остаёмся прозрачным и${NBSP}надёжным сервисом, помогая людям решать одну из${NBSP}главных задач в${NBSP}жизни${NBSP}— найти жильё. Наши технологии делают поиск проще и удобнее. Они повышают эффективность сервисов и позволяют Циан оставаться ключевым игроком рынка недвижимости.`,
          type: EDescriptionType.Text,
        },
      ],
    ],
  },
};

export const CONTENT: TContent = {
  main: Main,
  'core-business': CoreBusiness,
  'daily-business': DailyBusiness,
  'technologies-cian': TechnologiesCian,
  'transactional-business': TransactionalBusiness,
};
